import { socket } from "../socket";
import { useEffect, useState } from "react";
import { useGame } from "./useGame.ts";
import { tickEventSchema } from "../schemas/socketEvents.ts";

export const useGameTime = (gameId?: string): number => {
  const [time, setTime] = useState<number>(0);
  const game = useGame(gameId);

  useEffect(() => {
    const handleTick = (event: unknown) => {
      const result = tickEventSchema.safeParse(event);
      if (!result.success) {
        console.warn("Invalid tick event received:", result.error.message);
        return;
      }

      console.log(`tick - ${result.data.gameId} - ${result.data.time}`);
      if (result.data.gameId == gameId) {
        setTime(result.data.time);
      }
    };

    socket.on("tick", handleTick);

    return () => {
      socket.off("tick", handleTick);
    };
  }, [gameId]);

  useEffect(() => {
    if (!game.isSuccess) {
      return;
    }

    if (!game.data.started) {
      setTime(game.data.duration);
    }

    if (game.data.clockPausedAt) {
      setTime(game.data.clockPausedAt);
    }
  }, [
    game.isSuccess,
    game.data?.started,
    game.data?.duration,
    game.data?.clockPausedAt,
  ]);

  return time;
};
